module.exports = __webpack_public_path__ + "static/img/1000000439_blue.21f4428c.jpg";